const ROUTE_PATH = {
    LOGIN: '/',
    DASHBOARD: '/dashboard',
    REPORT: '/reports',
    REPORT_EXTENSIONS: '/reports/extensions',
    REPORT_DETAIL: '/reports/:id',
    REPORT_UPDATE: '/reports/update',
    REPORT_STATISTICS: '/reports/statistics',
    REPORT_USERS: '/reports/users',
    REPORT_EXPORT: '/reports/export',
    NEWS: '/news',
    PROCEDURES: '/procedures',
    TEMPLATES: '/templates',
    CONTACT: '/contact',
    SCHEDULES: '/schedules',
    STATISTICS: '/statistics',
    ACCOUNTS: '/accounts',
    NOT_FOUND: '*',
    REPORT_AREAS: '/report-areas',
    AREAS: '/areas',
    FORGOT_PASSWORD: '/forgot-password',
    GOVERNMENT: '/government',
    PERMISSIONS: '/permissions',
    ROLE_CREATE: '/permissions/create',
    ROLE_EDIT: '/permissions/:roleId/edit',
    AUDIT_LOG: '/audit-log',
    CATEGORY_NEWS: '/category-news',
    DOCUMENTS: '/documents',
    DOCUMENTS_HISTORY: '/documents/history',
    DOCUMENTS_LEGAL: '/documents/legal',
    DOCUMENTS_CATEGORIES: '/documents/categories',
    COUNTER_RECEPTION_FEEDBACK: '/admin/counter-reception-feedback',
    LEADER_MEETING_FEEDBACK: '/admin/leader-meeting-feedback',
    ADD_LEADER_SCHEDULE: '/admin/schedules/add',
    LEADER_MEETING_RATINGS: '/admin/leader-meeting-ratings',
    KIOSK_TIEP_DAN: '/kiosk/tiepdan'
}
export default ROUTE_PATH;